//POST ai/skillcontrol/me/authorize: the authorization page the sign-in popup opens
export class SkillControlSignInStartDTO {
  authorizationUrl: string;

  constructor() {
    this.authorizationUrl = '';
  }
}

//POST ai/skillcontrol/me/authorize/complete: what the callback page handed the window that opened the popup
export class SkillControlSignInCompleteDTO {
  code: string;

  state: string;

  constructor(code: string, state: string) {
    this.code = code;
    this.state = state;
  }
}
